module.exports = __webpack_public_path__ + "static/media/upcoming-exam.ec8545be.jpg";